<template>
  <component
    :is="to ? RouterLink : 'button'"
    :to="to"
    class="item-container mx-2 block w-[calc(100%-1rem)] px-3 py-1 first:-mb-2 first:rounded-t-md first:pb-3 first:pt-1.5 first:shadow-[inset_0px_-18px_10px_-10px_rgba(0,0,0,0.1)] last:-mt-2 last:rounded-b-md last:pt-3 last:shadow-[inset_0px_18px_10px_-10px_rgba(0,0,0,0.1)]"
    :style="`--bg-color: var(--${variant}-bg); --content-color: var(--${variant}-content); background: var(--bg-color)`"
    @click.prevent="onClick?.()"
  >
    <slot />
  </component>
</template>

<script lang="ts" setup>
import { type RouteLocationRaw, RouterLink } from 'vue-router';
import type { ListItemVariant } from './ListItem.vue';

withDefaults(
  defineProps<{
    to?: RouteLocationRaw;
    onClick?: () => void;
    variant?: ListItemVariant;
  }>(),
  { variant: 'default' },
);
</script>

<style scoped>
.item-container {
  --default-bg: var(--color-card-default-bg);
  --default-content: var(--color-card-default-content);
  --success-bg: var(--color-card-success-bg);
  --success-content: var(--color-card-success-content);
  --info-bg: var(--color-card-info-bg);
  --info-content: var(--color-card-info-content);
  --transition-bg: linear-gradient(
    90deg,
    var(--color-card-success-bg) 0%,
    var(--color-card-info-bg) 100%
  );
  --transition-content: var(--color-card-success-content);
  --warning-bg: var(--color-card-warning-bg);
  --warning-content: var(--color-card-warning-content);
  --problem-bg: var(--color-card-problem-bg);
  --problem-content: var(--color-card-problem-content);
  --danger-bg: var(--color-card-danger-bg);
  --danger-content: var(--color-card-danger-content);
  --orange-bg: var(--color-card-orange-bg);
  --orange-content: var(--color-card-orange-content);
}
</style>
